<template>
  <div id="AddExam" class="wrap">
    <v-app-bar class="grey lighten-3 desktopHeader--remove hidden-md-and-up" fixed elevate-on-scroll>
      <v-layout justify-center align-center>
        <span class="title blue--text text--darken-3 ml-1"> Add Exam</span>
      </v-layout>
    </v-app-bar>
    <div class="maxContainer">
      <div class="HealthcareHours__cover offset-md-3 col-md-6 offset-sm-2 col-sm-8">
        <div @click="back" class="headerFake__back">
          <a class="headerFake__backLink">
            <v-icon class="mr-3" medium color="red">mdi-arrow-left</v-icon>
            <span class="headerFake__backText">Back</span>
          </a>
        </div>
        <v-card class=" mb-5 pt-5" flat >
          <v-card-text class="mt-0 pt-0 px-0">
             <v-layout justify-center align-center class="hidden-sm-and-down mb-3">
                <span class="title blue--text text--darken-3 ml-1"> Add Exam</span>
              </v-layout>
            <v-container  grid-list-md pt-0 px-1>
              <v-form>
                <!-- Exam Type -->
                <v-select
                  color="green"
                  v-model="exam_type" 
                  :items="['GRE', 'CASper', 'MCAT', 'PA-CAT', 'TOEFL iBT', 'TOEFL PBT', 'PTE Academic', 'IELTS', 'MELAB', 'iTEP Academic', ]"
                  label="Select Exam"
                  clearable
                  outlined
                  hide-details>
                </v-select>

                <!-- Exam Completed or Scheduled -->
                <v-layout class="mt-2 ml-1">
                  <v-radio-group v-model="examStatus" row >
                    <v-radio color="green" label="Scheduled" value="Scheduled"></v-radio>
                    <v-radio color="green" label="Completed" value="Completed"></v-radio>
                  </v-radio-group>
                </v-layout>

                <!--  Exam Date -->
                <v-flex v-if="examStatus !== null" xs12>
                  <v-menu
                    ref="menu2"
                    :close-on-content-click="false"
                    v-model="menu2"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    full-width
                    min-width="290px">
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      slot="activator"
                      :value="computedDateFormattedMomentjs"
                      :label="`${examStatus === 'Completed' ? 'Completed' : 'Scheduled'} Exam Date`"
                      prepend-inner-icon="mdi-calendar"
                      readonly
                      class="pt-1"
                      clearable
                      outlined
                      v-on="on"
                    ></v-text-field>
                  </template>
                    <v-date-picker v-model="date" no-title @input="menu2 = false"></v-date-picker>
                  </v-menu>
                </v-flex>
              </v-form>

              <!-- Add Exam Button -->
              <v-layout row class="mt-2 mb-3">
                <v-btn
                  color="green"
                  @click="addExam()"
                  large
                  block
                  :disabled="checkAddExam">
                  <span class="white--text"> Save</span>
                </v-btn>
              </v-layout>
            </v-container>
          </v-card-text>
        </v-card>
      </div>
    </div>
    <!-- Back Button -->
    <v-btn  class="mr-4 ml-2  fixed elevation-0" color="red"  fab rounded small @click="back"> <v-icon  medium color="white">mdi-arrow-left</v-icon></v-btn>
  </div>

</template>


<script>
  import moment from 'moment'
  export default {
     data() {
      return {
        modal: false,
        alert: false,
        menu2: false,
        AddExamDialog: false,
        exam_type : '',
        examStatus: null,
        date : null,
        dateFormatted: this.formatDate(new Date().toISOString().substr(0, 10)),

        gre_combined_score: '',
        gre_verbal_reasoning_score: '',
        gre_analytical_writing_score: '',
        gre_quantitative_reasoning_score: '',
        gre_combined_percentile_score: '',
        gre_verbal_percentile_score: '',
        gre_quantitative_percentile_score: '',
        gre_analytical_percentile_score: '',
        
        mcat_total_score: '',

        toeflIbt_total_score: '',
        toeflIbt_reading_score: '',
        toeflIbt_listening_score: '',
        toeflIbt_speaking_score: '',
        toeflIbt_writing_score: '',

        toeflPbt_total_score: '',
        toeflPbt_reading_score: '',
        toeflPbt_writing_score: '',
        toeflPbt_listening_score: '',

        pteAcademic_overall_score: '',
        ielts_overall_score: '',
        melab_overall_score: '',
        itepAcademic_overall_score: '',

      }
    },
    methods: {
      formatDate (date) {
        if (!date) return null

        const [year, month, day] = date.split('-')
        return `${month}/${day}/${year}`
      },
      parseDate (date) {
        if (!date) return null

        const [month, day, year] = date.split('/')
        return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
      },
      back () {
        if( window.innerWidth < 960 ) {
          this.$router.push('/dashboard/exams')
        } else {
          this.$router.push('/dashboard')
        }
        this.examStatus = null
      },
      showAddExamDialog(user) {
        if(user !== null && user !== undefined ){
          this.AddExamDialog = true
        }
        else {
          this.alert = true
        }
      },
      addExam () {
        
        // Add GRE Data
        if(this.exam_type === 'GRE') {
          const greExamData = {
            exam_type: this.exam_type,
            examStatus: this.examStatus,
            date: this.date,
            gre_combined_score: this.gre_combined_score,
            gre_verbal_reasoning_score: this.gre_verbal_reasoning_score,
            gre_analytical_writing_score: this.gre_analytical_writing_score,
            gre_quantitative_reasoning_score : this.gre_quantitative_reasoning_score,
            gre_combined_percentile_score: this.gre_combined_percentile_score,
            gre_verbal_percentile_score: this.gre_verbal_percentile_score,
            gre_quantitative_percentile_score: this.gre_quantitative_percentile_score,
            gre_analytical_percentile_score: this.gre_analytical_percentile_score,
            exam_scores : false
          }

          this.$store.dispatch('setAddExam', greExamData)
        }

         // Add PA-CAT Data
        if(this.exam_type === 'PA-CAT') {
          const pacatExamData = {
            exam_type: this.exam_type,
            examStatus: this.examStatus,
            date: this.date,
            exam_scores : false
          }

          this.$store.dispatch('setAddExam', pacatExamData )
        }

        // Add CASper Data
        if(this.exam_type === 'CASper') {
          const casperExamData = {
            exam_type: this.exam_type,
            examStatus: this.examStatus,
            date: this.date,
            exam_scores : false
          }

          this.$store.dispatch('setAddExam', casperExamData )
        }

        // Add MCAT Data
        if(this.exam_type === 'MCAT') {
          const mcatExamData = {
            exam_type: this.exam_type,
            examStatus: this.examStatus,
            date: this.date,
            mcat_total_score: this.mcat_total_score,
            exam_scores : false
          }

          this.$store.dispatch('setAddExam', mcatExamData)
        }

        // Add TOEFL iBT Data
        if(this.exam_type === 'TOEFL iBT') {
          const toeflIbtExamData = {
            exam_type: this.exam_type,
            examStatus: this.examStatus,
            date: this.date,
            toeflIbt_total_score: this.toeflIbt_total_score,
            toeflIbt_reading_score: this.toeflIbt_reading_score,
            toeflIbt_listening_score: this.toeflIbt_listening_score,
            toeflIbt_speaking_score: this.toeflIbt_speaking_score,
            toeflIbt_writing_score: this.toeflIbt_writing_score,
            exam_scores : false
          }

          this.$store.dispatch('setAddExam', toeflIbtExamData)
        }

        // Add TOEFL PBT Data
        if(this.exam_type === 'TOEFL PBT') {
          const toeflPbtExamData = {
            exam_type: this.exam_type,
            examStatus: this.examStatus,
            date: this.date,
            toeflPbt_total_score: this.toeflPbt_total_score,
            toeflPbt_reading_score: this.toeflPbt_reading_score,
            toeflPbt_writing_score: this.toeflPbt_writing_score,
            toeflPbt_listening_score: this.toeflPbt_listening_score,
            exam_scores : false
          }

          this.$store.dispatch('setAddExam', toeflPbtExamData)
        }

        // Add PTE Academic Data
        if(this.exam_type === 'PTE Academic') {
          const pteAcademicExamData = {
            exam_type: this.exam_type,
            examStatus: this.examStatus,
            date: this.date,
            pteAcademic_overall_score: this.pteAcademic_overall_score,
            exam_scores : false
          }

          this.$store.dispatch('setAddExam', pteAcademicExamData)
        }

        // Add IELTS Data
        if(this.exam_type === 'IELTS') {
          const ieltsExamData = {
            exam_type: this.exam_type,
            examStatus: this.examStatus,
            date: this.date,
            ielts_overall_score: this.ielts_overall_score,
            exam_scores : false
          }

          this.$store.dispatch('setAddExam', ieltsExamData)
        }

        // Add MELAB Data
        if(this.exam_type === 'MELAB') {
          const melabExamData = {
            exam_type: this.exam_type,
            examStatus: this.examStatus,
            date: this.date,
            melab_overall_score: this.melab_overall_score,
            exam_scores : false
          }

          this.$store.dispatch('setAddExam', melabExamData)
        }

         // Add iTEP Academic Data
        if(this.exam_type === 'iTEP Academic') {
          const itepAcademicExamData = {
            exam_type: this.exam_type,
            examStatus: this.examStatus,
            date: this.date,
            itepAcademic_overall_score: this.itepAcademic_overall_score,
            exam_scores : false
          }

          this.$store.dispatch('setAddExam', itepAcademicExamData)
        }
        
        this.$router.go(-1)
        this.examStatus = null
        
      }
    },
    computed : {
      user () {
        return this.$store.getters.user
      },
      computedDateFormattedMomentjs () {
        return this.date ? moment(this.date).format('MM/DD/YYYY') : ''
      },
      checkAddExam() {
        if((this.exam_type === '' || this.exam_type === undefined) || this.examStatus === null || (this.date === null || this.date === undefined)) {
          return true
        } else {
          return false
        }
      }
    },
 

  }
</script>

<style scoped>
  .fixed {
    position: fixed;
    bottom: 0;
    right: 0;
    margin-bottom:65px;    
  }

   #buttonShadow {
    box-shadow: 0 10px 30px -10px rgba(0,0,0,.19);
  }
.headerFake__back {
  text-align: left;
  position: relative;
  display: none;
}
.headerFake__backLink {
  cursor: pointer;
}
.headerFake__backText {
  position: absolute;
  top: 0;
  left: 32px;
  line-height: 26px;
  color: initial;
}

@media (min-width: 960px) {
  .headerFake__back {
    display: block;
  }
  .fixed {
    display: none;
  }
}

.maxContainer {
  max-width: 1280px;
  margin: 0 auto;
}

.wrap {
  margin-top: 8vh !important;
}
</style>


// WEBPACK FOOTER //
// src/components/Dashboard/Exams/AddExam.vue